<template>
  <v-dialog :value="model.active" width="400" persistent style="z-index: 2100 !important">
    <!-- Modal content -->
    <v-card>
      <div class="d-flex justify-space-between align-center pr-2">
        <v-card-title class="text-h6 font-weight-bold">
          <v-icon left>mdi-plus</v-icon>
          Add Document
        </v-card-title>
        <v-btn icon @click="closeDialog"><v-icon>fa-close</v-icon></v-btn>
      </div>
      <v-divider></v-divider>

      <v-card-text class="pt-5" ref="movableContainer">
        <div class="modal-body" :class="{ 'amis-body': isAMIS }">
          <v-sheet
            height="200px"
            class="drag-area d-flex align-center flex-column justify-center rounded-lg"
            style="border-style: dashed"
            outlined
            @click.stop="addAttachment()">
            <v-icon class="mb-2" x-large>mdi-file-upload-outline</v-icon>
            <div>
              <input
                type="file"
                :multiple="!options.singleFile"
                style="display: none"
                id="uploadAttachmentFile"
                @change="uploadAttachment($event)" />
              Drag and drop or
              <a @click.stop="addAttachment()" class="text-decoration-underline mx-1"
                >choose file</a
              >
              to upload
            </div>
          </v-sheet>
          <div style="margin: 7px; position: relative" v-if="isAMIS">
            <CustomSelectBox
              :id="'upload-attachment-section-filter'"
              :is_multiple="false"
              :with_search="false"
              :show_checkbox="false"
              :options="types"
              :custom_icon_class="'fas fa-folder-open'"
              @filter_check_changed="filterCheckChanged">
            </CustomSelectBox>
          </div>
          <v-list class="overflow-y-auto" v-if="!!selected.length" style="max-height: 80vh">
            <v-list-item
              dense
              class="bg1 mb-1 rounded-lg"
              v-for="file in selected"
              :key="file.name + file.lastModified">
              <v-list-item-content>
                <v-list-item-title>{{ file.name }}</v-list-item-title>
                <v-list-item-subtitle>Size: {{ getSize(file.size) }}</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn icon color="error">
                  <v-icon @click="remove(file)">mdi-close</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn color="red" elevation="0" text @click="closeDialog"> close </v-btn>
        <v-spacer></v-spacer>
        <v-btn elevation="0" :disabled="!model.hasChanges" @click="discard"> discard </v-btn>
        <v-btn
          color="primary"
          elevation="0"
          :loading="uploading"
          @click="submit"
          :disabled="!model.valid || !model.hasChanges || !selected.length || uploading">
          Upload
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import { $handleError, $isEqual } from '@/utils';
  import CustomSelectBox from '../common/customSelectBox.vue';
  import DocumentService from '@Task/service/documents.service.js';
  export default {
    name: 'AddDocumentModal',
    props: ['parent_type', 'parent_id', 'apiUrl'],
    data() {
      return {
        selected: [],
        uploading: false,
        masterDocsFolder: 'MasterDocs',
        types: [],
        isMoving: false,
        initialX: 0,
        initialY: 0,
        xOffset: 0,
        yOffset: 0,
        selectedCemented: [],
        uploadResult: [],
        options: {
          singleFile: false,
        },
        model: {
          active: false,
          loading: false,
          valid: true,
          hasChanges: false,
        },
      };
    },
    activated() {
      this.clearInput();
    },
    methods: {
      clearInput() {
        var input = document.getElementById('uploadAttachmentFile');
        if (input) {
          input.value = '';
        }
      },
      open(options) {
        if (options) {
          Object.assign(this.options, options);
        } else {
          this.options = this.getDefaultOptions();
        }

        this.model.active = true;
        setTimeout(() => {
          var dropContainer = document.getElementsByClassName('drag-area').item(0);
          dropContainer.ondragover = dropContainer.ondragenter = function (evt) {
            evt.preventDefault();
          };
          dropContainer.ondrop = (evt) => {
            evt.preventDefault();
            this.onDrop(evt);
          };
          document.addEventListener('mousemove', this.mouseMove);

          this.types = this.documentTypes.map((d) => {
            return {
              ...d,
              isChecked: d.name === this.defaultDocumentType,
            };
          });
        }, 2000);
      },
      getDefaultOptions() {
        return {
          singleFile: false,
        };
      },
      reset() {
        this.clearInput();
        this.model.active = false;
        this.selected = [];
        this.selectedCemented = [];
      },
      closeDialog() {
        if (this.model.hasChanges) {
          const answer = window.confirm('You have unsaved changes on this page! leave anyway?');
          if (answer) {
            this.reset();
            this.discard();
          }
        } else {
          this.reset();
        }
      },
      discard() {
        this.selected = structuredClone(this.selectedCemented);
        this.model.hasChanges = false;
      },
      cementSelected() {
        this.selectedCemented = structuredClone(this.selected);
        this.checkForChanges();
      },
      checkForChanges() {
        if (!this.model.active) return;

        this.model.hasChanges = !$isEqual(this.selected, this.selectedCemented);
      },
      dragStart(e) {
        this.initialX = e.clientX - this.xOffset;
        this.initialY = e.clientY - this.yOffset;
        if (e.target === this.$refs.moveButton) {
          this.isMoving = true;
        }
      },
      dragEnd() {
        this.isMoving = false;
      },
      mouseMove(e) {
        if (this.isMoving) {
          e.preventDefault();
          let currentX = e.clientX - this.initialX;
          let currentY = e.clientY - this.initialY;
          this.xOffset = currentX;
          this.yOffset = currentY;
          this.setTranslate(currentX, currentY, this.$refs.movableContainer);
        }
      },
      setTranslate(xPos, yPos, el) {
        el.style.transform = `translate3d(${xPos}px, ${yPos}px, 0)`;
      },
      onCloseClicked() {
        this.closeDialog();
      },
      submit() {
        if (!this.selected.length) return;

        this.uploading = true;
        DocumentService.upload(this.selected)
          .then((res) => {
            this.uploading = false;
            this.uploadResult = res;
            this.$emit('uploadCompleted', res);
            this.cementSelected();
            this.closeDialog();
          })
          .catch(() => {
            $handleError({ message: 'Error while uploading files, please try again.' });

            this.uploading = false;
          });
      },
      addAttachment() {
        document.getElementById('uploadAttachmentFile').click();
      },
      remove(file) {
        this.selected = this.selected.filter((f) => f != file);
      },
      uploadAttachment($event) {
        if ($event.target.files.length == 0) return;
        this.selected = [];
        for (var i = 0; i < $event.target.files.length; i++) {
          this.selected.push($event.target.files[i]);
        }
      },
      onDrop(ev) {
        this.selected = [];
        for (var i = 0; i < ev.dataTransfer.files.length; i++) {
          this.selected.push(ev.dataTransfer.files[i]);
        }
      },
      getSize(size) {
        if (size < 1024) {
          return size + ' B';
        } else if (size < 1024 * 1024) {
          return (size / 1024).toFixed(1) + ' KB';
        } else {
          return (size / (1024 * 1024)).toFixed(1) + ' MB';
        }
      },
      filterCheckChanged({ option }) {
        this.types.forEach((t) => (t.isChecked = false));
        option.isChecked = true;
      },
    },
    computed: {
      assetId: function () {
        return this.$store.state.assetId;
      },

      documentTypes: function () {
        let types = this.$store.getters['GET_DOCUMENT_TYPES'] ?? [];
        return [...types];
      },
      defaultDocumentType: {
        get() {
          return this.$store.getters['GET_DEFAULT_DOCUMENT_TYPE'];
        },
        set(value) {
          this.$store.commit('SET_DEFAULT_DOCUMENT_TYPE', value);
        },
      },
      isAMIS() {
        return !!this.$store.state.forgeSettings?.isAMIS;
      },
    },
    created() {
      this.clearInput();
    },
    destroyed() {
      document.removeEventListener('mousemove', this.mouseMove);
    },
    watch: {
      documentTypes: {
        handler: function (value) {
          if (!value?.length) return;

          this.types = value.map((d) => {
            return {
              ...d,
              isChecked: d.name === this.defaultDocumentType,
            };
          });
        },
        deep: true,
      },
      selected: {
        handler() {
          this.checkForChanges();
        },
        deep: true,
      },
    },
    components: { CustomSelectBox },
  };
</script>

<style>
  .add-document-popup-content {
    display: flex;
    flex-direction: column;
  }

  .drag-area:hover {
    background-color: var(--v-bg1-base);
  }

  .add-document-popup .add-document-popup-header {
    background: var(--v-primary-base);
    border-radius: 5px 5px 0 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0px 10px;
  }

  .add-document-popup .add-document-popup-header p {
    font-weight: bold;
    font-size: 20px;
    margin: 10px;
    color: #f2f2f2;
  }

  .add-document-popup .add-document-popup-header .fas.fa-times {
    font-size: 20px;
    color: var(--v-primary-lighten3);
    padding: 5px;
  }

  .add-document-popup .add-document-popup-header .fas.fa-times:hover {
    color: white;
  }

  .add-document-popup .uploaded-area {
    margin: 10px;
  }

  .add-document-popup .modal-footer {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 15px 25px;
  }

  .add-document-popup .wide-btn {
    margin: 0;
  }

  .file-card {
    border: 1px solid #c7c7c7;
    border-radius: 5px;
    padding: 10px;
    display: flex;
    column-gap: 15px;
    box-shadow: 0px 0px 2px rgb(0 0 0 / 25%);
    align-items: center;
    margin-top: 10px;
  }

  .file-card i {
    cursor: pointer;
    padding: 5px;
    font-size: 18px;
  }
  .file-card i:hover {
    color: var(--v-primary-base);
  }

  .file-card .file-size {
    color: #a1a1a1;
    font-size: 12px;
    position: relative;
    left: 3px;
    bottom: 4px;
  }

  .uploaded-area {
    max-height: 400px;
    background: white;
    padding: 5px 25px;
  }

  .add-document-popup .wide-btn.disabled {
    background: #dadada;
    pointer-events: none;
  }

  .modal-body.amis-body {
    overflow: visible;
  }

  .modal-body.amis-body .select-box-container .select-box-div {
    width: 100%;
  }

  .model-body.amis-body .select-box-btn {
    font-size: 18px;
  }
</style>
